import { notifyOnError } from '~/rage';
import { IObservable, Subject } from '~/rage/utils';
import { GameConfigService } from '../GameConfigService';
import { RpcService } from '../RpcService';
import { IJobElectricianService } from './jobElectricianServiceTypes';

export class JobElectricianService implements IJobElectricianService {
	private readonly DEFAULT_GAME_TIME_MS = 30 * 1000;

	private gameTimeCircuit = new Subject<number>(this.DEFAULT_GAME_TIME_MS);
	private gameTimeWires = new Subject<number>(this.DEFAULT_GAME_TIME_MS);
	private gameTimeSwitch = new Subject<number>(this.DEFAULT_GAME_TIME_MS);

	constructor(
		private readonly rpc: RpcService,
		private readonly gameConfig: GameConfigService,
	) {
		this.gameConfig.getConfigs().subscribe((configs) => {
			if (!configs) {
				return;
			}

			const timeCircuitMs =
				configs.jobElectrician?.minigameTimeCircuitMs ??
				this.DEFAULT_GAME_TIME_MS;
			const timeWiresMs =
				configs.jobElectrician?.minigameTimeWiresMs ??
				this.DEFAULT_GAME_TIME_MS;
			const timeSwitchMs =
				configs.jobElectrician?.minigameTimeSwitchMs ??
				this.DEFAULT_GAME_TIME_MS;

			this.gameTimeCircuit.next(timeCircuitMs);
			this.gameTimeWires.next(timeWiresMs);
			this.gameTimeSwitch.next(timeSwitchMs);
		});
	}

	public getGameTimeCircuit(): IObservable<number> {
		return this.gameTimeCircuit;
	}

	public getGameTimeWires(): IObservable<number> {
		return this.gameTimeWires;
	}

	public getGameTimeSwitch(): IObservable<number> {
		return this.gameTimeSwitch;
	}

	@notifyOnError
	public async reportWin(): Promise<void> {
		await this.rpc.invokeServer('jobElectrician:reportWin');
	}

	@notifyOnError
	public async reportLoss(): Promise<void> {
		await this.rpc.invokeServer('jobElectrician:reportLoss');
	}
}
